import { defaultPreset } from './default'
import { threeColPreset } from './threeCol'
import { quotesPreset } from './quotes'
import { oneColPreset } from './oneCol'
import { homeIntroPreset } from './homeIntro'
import { continuedExploringPreset } from './continuedExploring'
import { menuSliderPreset } from './menuSlider'
import { sliderCardsPreset } from './sliderCards'

export const presets = {
  default: defaultPreset,
  threeCol: threeColPreset,
  quotes: quotesPreset,
  oneCol: oneColPreset,
  homeIntro: homeIntroPreset,
  continuedExploring: continuedExploringPreset,
  menuSlider: menuSliderPreset,
  sliderCards: sliderCardsPreset,
}
